import { render, staticRenderFns } from "./Si.vue?vue&type=template&id=3cf5c2bc"
import script from "./Si.vue?vue&type=script&lang=js"
export * from "./Si.vue?vue&type=script&lang=js"
import style0 from "./Si.vue?vue&type=style&index=0&id=3cf5c2bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports